<script setup>
import { reactive, ref } from 'vue'
import ManGroup from '../ManGroup.vue'
import { useMetaStore } from '@/stores'
import { down, ensureRef, get, isImgFile, loadEpsgs, post, postMultipart, qsel, validators, ymd } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import _ from 'lodash-es'
import { senitizeFileName } from '../../../common/util'
import config from '@/common/config'
import { useRoute, useRouter } from 'vue-router'
import UploadLayer from '@/components/UploadLayer.vue'
const metaStore = useMetaStore(), mangroup = ref(null), route = useRoute(), router = useRouter()
  , meta = reactive({
    epsgs: [-1], selgroup: null, initlayer: { layerkind: 'vector', layertype: 'Point', inputtype: 'directinput_shp', epsg: -1, groupid: 'defaultgroups', encoding: 'UTF-8', etc: null, minx: 126.7, miny: 37.4, maxx: 127.2, maxy: 37.7 }, selapigroup: null
    , layerkinds: ['vector', 'raster', 'api'], layertypes: ['Point', 'LineString', 'Polygon'], inputtypes: ['directinput_shp', 'directinput_gpkg', 'uploadfile'], tartbl: 'Layer', tblheight: 400, data: { rows: [] }
    , search: { page: 1, size: 20, sortcol: 'mdt', isasc: false, where: { nm: '', groupid_eq_: null } }, heads: [{ tk: 'layerkind', col: 'layerkind' }, { tk: 'layertype', col: 'layertype' }, { tk: 'layername', col: 'nm' }, { tk: 'coordinatesystem', col: 'epsg' }, { tk: 'dateofmod', col: 'mdt' }]
    , downparam: { service: '', format: '', bbox: '', selservice: 'WFS' }
    , layerfiletypes: [{ ext: 'zip', type: 'vector' }, { ext: 'geojson', type: 'vector' }, { ext: 'gpkg', type: 'vector' }, { ext: 'json', type: 'vector' }, { ext: 'gpx', type: 'vector' }, { ext: 'kml', type: 'vector' }
      , { ext: 'jpg', type: 'raster' }, { ext: 'png', type: 'raster' }, { ext: 'gif', type: 'raster' }, { ext: 'tif', type: 'raster' }]
  })
  , inputfile = ref(null)
  , pop = async (type, layer) => {
    meta.poptype = null
    meta.sellayer = layer;
    let persist = false
    if (type == 'add') {
      apis()
      meta.addoverlay = null
      meta.newlayer = { ...meta.initlayer }
      meta.newlayer.groupid = meta.selgroup ? meta.selgroup.id : 'defaultgroups'
      persist = true
    }
    if (type == 'down') {
      meta.downparam.service = layer.layerkind == 'vector' ? 'wfs' : 'wms'
      meta.downparam.selservice = meta.downparam.service.toUpperCase()
      meta.capa = await get('rest/authed/member/capabilities/' + meta.downparam.service + '/1.1.1')
      meta.capa = meta.capa.data
      meta.downparam.wfsoutformats = []
      if (meta.downparam.service == 'wfs') {
        meta.selbbox = meta.capa.FeatureTypeList.FeatureType.find(ft => ft.Name.endsWith(layer.gslayernm)).WGS84BoundingBox
        meta.selbbox = [...meta.selbbox.LowerCorner.split(' '), ...meta.selbbox.UpperCorner.split(' ')]
        meta.downparam.format = 'csv'
        meta.downparam.wfsoutformats = meta.capa.OperationsMetadata.Operation.find(item => item.name == 'GetFeature').Parameter.find(item => item.name == 'outputFormat')
        meta.selbbox.forEach((val, idx) => meta.selbbox[idx] = parseFloat(val))
      } else {
        meta.selbbox = meta.capa.Capability.Layer.Layer.find(ft => ft.Name.endsWith(layer.gslayernm)).LatLonBoundingBox
        meta.selbbox = [parseFloat(meta.selbbox.minx), parseFloat(meta.selbbox.miny), parseFloat(meta.selbbox.maxx), parseFloat(meta.selbbox.maxy)]
        meta.downparam.format = 'image/gif'
      }
    }
    metaStore.pop({ ison: type != null, persist, callback: () => meta.poptype = type })
  }, delLayer = async () => {
    metaStore.blockLoading()
    const res = await post('rest/authed/admin/data/dellayer', { id: meta.delid })
    delete meta.delid
    metaStore.blockLoading(false)
    metaStore.toastRslt(res, false)
    search()
  }, addLayer = async () => {
    meta.addoverlay = 'loading'
    if (meta.newlayer.groupid == 'defaultgroups') meta.newlayer.groupid = null
    if (meta.newlayer.file) {
      metaStore.toastmaker({
        component: UploadLayer, props: {
          newlayer: meta.newlayer, onRslt: res => {
            meta.addoverlay = null
            if (res.isSuccess) {
              pop()
              search()
            }
            metaStore.toastRslt(res, true)
          }
        }
      }, {
        position: "top-right",
        timeout: false,
        closeOnClick: false,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        draggable: false,
        draggablePercent: 0,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: false,
        icon: false
      })
    } else {
      const res = await postMultipart('rest/authed/admin/data/addlayer', meta.newlayer)
      meta.addoverlay = null
      if (res.isSuccess) {
        pop()
        search()
      }
      metaStore.toastRslt(res, true)
    }

  }, apis = async (needblock) => {
    if (needblock) metaStore.blockLoading()
    const res = await get('rest/authed/admin/data/simpleextapis')
    if (needblock) metaStore.blockLoading(false)
    meta.apis = res.data.apis
    meta.apigroups = res.data.groups
    meta.apigroups.unshift({ id: null, nm: metaStore.t('defaultgroups') })
  }, toEdit = (id) => {
    metaStore.searchParams.layer = { ...meta.search }
    router.push({ path: '/admin/editlayer/' + id })
  }, initGroups = async () => {
    metaStore.blockLoading()
    const res = await get('rest/authed/member/groups/' + meta.tartbl)
    metaStore.blockLoading(false)
    meta.groups = res.data
    meta.groups.unshift({ id: 'defaultgroups', nm: metaStore.t('defaultgroups'), tartbl: meta.tartbl })
  }, changeSection = (section, val) => {
    meta.newlayer.file = null
    if (section == 'layerkind' && val == 'raster') meta.newlayer.inputtype = 'uploadfile'
    else if (section != 'inputtype') meta.newlayer.inputtype = 'directinput'
    if (meta.newlayer.inputtype == 'uploadfile' && meta.newlayer.layerkind != 'api') ensureRef(inputfile, val => {
      const fileobj = qsel(val.$el, '[type=file]')
      fileobj.accept = meta.layerfiletypes.filter(ft => ft.type == meta.newlayer.layerkind).map(ft => '.' + ft.ext).toString()
    })
  }, selFile = file => {
    if (!file || file.size == 0) {
      meta.newlayer.file = null
      return
    }
    const exts = meta.layerfiletypes.filter(ft => ft.type == meta.newlayer.layerkind).map(ft => '.' + ft.ext)
    if (!exts.some(ext => file.name.toLowerCase().endsWith(ext))) {
      meta.newlayer.file = null
      metaStore.toastKey('theresaproblemwiththefileyouuploaded', false)
      qsel(inputfile.value.$el, '.mdi-close-circle').click()
      return
    }
    if (meta.newlayer.layertype == 'Polygon' && file.name.toLowerCase().endsWith('.gpx')) {
      meta.newlayer.file = null
      metaStore.toastKey('notallowgpxonpolygon', false)
      qsel(inputfile.value.$el, '.mdi-close-circle').click()
      return
    }
    meta.newlayer.file = file
  }, dispAddOpts = section => {
    if (section == 'layertype' && meta.newlayer.layerkind == 'raster') return false
    if (meta.newlayer.layerkind == 'api' && section != 'layerkind') return false
    return true
  }, wfsUrl = ({
    service = 'WFS',
    version = '1.0.0',
    request = 'GetFeature',
    typeName = 'sample_line',
    maxFeatures = 99999,
    outputFormat = 'csv',
  }) => {
    return `${service.toLowerCase()}?` +
      `service=${encodeURIComponent(service)}&` +
      `version=${encodeURIComponent(version)}&` +
      `request=${encodeURIComponent(request)}&` +
      `typeName=${encodeURIComponent(typeName)}&` +
      `maxFeatures=${encodeURIComponent(maxFeatures)}&` +
      `outputFormat=${encodeURIComponent(outputFormat)}`;
  }, wmsUrl = ({
    service = 'WMS',
    version = '1.1.1',
    request = 'GetMap',
    layers = 'sample_line',
    bbox = '126.66835840124814,33.47583311800146,129.39935145587728,37.8336686864713',
    width = 1024,
    height = 768,
    srs = 'EPSG:4326',
    format = 'image/gif',
  }) => {
    return `${service.toLowerCase()}?` +
      `service=${encodeURIComponent(service)}&` +
      `version=${encodeURIComponent(version)}&` +
      `request=${encodeURIComponent(request)}&` +
      `layers=${encodeURIComponent(layers)}&` +
      `bbox=${encodeURIComponent(bbox)}&` +
      `width=${encodeURIComponent(width)}&` +
      `height=${encodeURIComponent(height)}&` +
      `srs=${encodeURIComponent(srs)}&` +
      `format=${encodeURIComponent(format)}`;
  }, downFile = group => {
    let url = wmsUrl({ layers: meta.sellayer.gslayernm, bbox: meta.selbbox.toString(), format: meta.downparam.format })
    if (meta.downparam.selservice == 'WFS') url = wfsUrl({ typeName: meta.sellayer.gslayernm, outputFormat: meta.downparam.format })
    down({ url: url, method: 'get' })
    pop()
    metaStore.toastKey('start_download')
  }, groupSelected = group => {
    meta.selgroup = group
    meta.search.where.groupid_eq_ = group ? group.id : null
    meta.search.page = 1
    search()
    initGroups()
  }, search = async () => {
    metaStore.blockLoading()
    const res = await post('rest/authed/member/searchlayers', meta.search)
    metaStore.blockLoading(false)
    meta.data = res.data
    meta.tblheight = window.innerHeight - 380
  }
if (metaStore.dispmode == 'minimum') meta.layerkinds.splice(2, 1)
if (metaStore.searchParams.layer) {
  meta.search = { ...metaStore.searchParams.layer }
  metaStore.searchParams.layer = null
}
loadEpsgs(epsgs => epsgs.forEach(epsg => meta.epsgs.push(epsg)))
search()
</script>
<template>
  <div class="manlayer">
    <v-row no-gutters w class="h-100 flex-nowrap">
      <v-col style="max-width: 485px;">
        <ManGroup ref="mangroup" :tartbl="meta.tartbl" :ispop="false" :usedefaultgroup="true" @on-sel="groupSelected"
          @on-search="groupSelected" />
      </v-col>
      <v-col class="layertblcol">
        <v-card flat :title="meta.selgroup ? meta.selgroup.nm : $t('defaultgroups')">
          <v-row>
            <v-col cols="6"><v-text-field hide-details variant="outlined" density="compact" class="ms-3"
                :label="$t('layername')" :placeholder="$t('enteralayername')" v-model="meta.search.where.nm" /></v-col>
            <v-col><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search" /></v-col>
            <v-col class="text-right pe-7"><v-btn color="primary" :text="$t('registeringlayers')"
                @click="pop('add')" /></v-col>
          </v-row>
          <v-card-text>
            <v-table class="layertbl" fixed-header :height="meta.tblheight">
              <thead>
                <tr>
                  <th class="text-no-wrap" v-for="head in meta.heads">{{ $t(head.tk) }}</th>
                  <th>{{ $t('viewdetails') }}</th>
                  <th>{{ $t('download') }}</th>
                  <th>{{ $t('delete') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in meta.data.rows">
                  <td v-for="head in meta.heads" class="text-no-wrap">
                    <div v-if="head.col == 'mdt'">{{ ymd(row.mdt) }}</div>
                    <div v-else-if="head.col == 'layerkind'">{{ $t(row[head.col]) }}</div>
                    <div v-else-if="head.col == 'layertype'">{{
                      row.layerkind == 'vector' ? $t(row[head.col].replace('Multi', '')) : '' }}</div>
                    <div v-else>{{ row[head.col] }}</div>
                  </td>
                  <td class="text-center"><v-btn :text="$t('viewdetails')" @click="toEdit(row.id)" /></td>
                  <td class="text-center"><v-btn v-if="row.gslayernm" prepend-icon="mdi-download-box-outline"
                      color="primary" :text="$t('download')" @click="pop('down', row)" /></td>
                  <td class="text-center"><v-btn color="error" :text="$t('delete')"
                      @click="meta.delid = row.id; metaStore.dialog({ shown: true, ttl: 'deletelayer', cont: 'del_con', showcancel: true, istk: true, onok: delLayer })" />
                  </td>
                </tr>
                <tr v-if="!meta.data.rows.length">
                  <td :colspan="meta.heads.length + 4" class="text-center">{{ $t('noresultsfound') }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card-text>
          <v-card-actions>
            <v-pagination class="ma-auto" v-if="meta.data.rows.length" :length="meta.data.totalPages"
              :total-visible="meta.data.pageCount" v-model="meta.search.page" @update:model-value="search" />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <Teleport v-if="meta.poptype" to="#popbody">
    <v-card flat v-if="meta.poptype == 'add'" min-width="550" rounded="0">
      <v-card-title>
        <v-row>
          <v-col align-self="center">{{ $t('selectingalayerregistrationmethod') }}</v-col>
          <v-col cols="2" class="text-right"><v-icon icon="mdi-close" class="cursor-pointer" @click="pop()" /></v-col>
        </v-row>
      </v-card-title>
      <v-alert class="ma-3" style="max-height: calc(100vh - 400px);overflow-y: auto;">
        <v-container fluid>
          <v-defaults-provider :defaults="{ VRadioGroup: { inline: true, hideDetails: true } }">
            <div v-for="lbl in ['layerkind', 'layertype', 'inputtype']" class="mb-2">
              <p v-if="dispAddOpts(lbl)">{{ $t(lbl) }}</p>
              <v-radio-group v-if="dispAddOpts(lbl)" v-model="meta.newlayer[lbl]"
                @update:model-value="val => changeSection(lbl, val)"
                :disabled="lbl == 'inputtype' && meta.newlayer.layerkind == 'raster'">
                <v-radio v-for="item in meta[lbl + 's']" :label="$t(item)" :value="item" />
              </v-radio-group>
            </div>
          </v-defaults-provider>
          <v-defaults-provider
            :defaults="{ global: { hideDetails: true, variant: 'outlined', density: 'compact', noGutters: true } }">
            <v-file-input v-if="meta.newlayer.inputtype == 'uploadfile'" class="mb-4" prepend-icon
              prepend-inner-icon="mdi-paperclip" :ref="obj => inputfile = obj" :label="$t('uploadfile')"
              @update:model-value="selFile" />
            <div v-if="meta.newlayer.layerkind == 'raster' && meta.newlayer.file && isImgFile(meta.newlayer.file.name)"
              class="rastercoords">
              <p>{{ $t('aboutreferencecoordinates') }}</p>
              <v-row>
                <v-col class="ma-2"><v-number-input inset hide-details :label="'Min X' + $t('coordinates')"
                    v-model="meta.newlayer.minx" /></v-col>
                <v-col class="ma-2"><v-number-input inset hide-details :label="'Min Y' + $t('coordinates')"
                    v-model="meta.newlayer.miny" /></v-col>
              </v-row>
              <v-row class="mb-2">
                <v-col class="ma-2"><v-number-input inset hide-details :label="'Max X' + $t('coordinates')"
                    v-model="meta.newlayer.maxx" /></v-col>
                <v-col class="ma-2"><v-number-input inset hide-details :label="'Max Y' + $t('coordinates')"
                    v-model="meta.newlayer.maxy" /></v-col>
              </v-row>
            </div>
            <v-select class="mb-4" v-if="meta.newlayer.layerkind != 'api' && meta.newlayer.layerkind != 'raster'"
              :items="['UTF-8']" v-model="meta.newlayer.encoding" :label="$t('encodingtype')" />
            <v-select class="mb-4" v-if="meta.newlayer.layerkind != 'api' && meta.newlayer.layerkind != 'raster'"
              :items="meta.epsgs" v-model="meta.newlayer.epsg" :label="$t('coordinatesystem')"
              :item-props="item => item == -1 ? { title: $t('auto'), value: item } : { title: 'EPSG:' + item, value: item }" />
            <div v-if="meta.newlayer.layerkind == 'api'">
              <v-select class="mb-4" :label="'API' + $t('groupname')" v-model="meta.selapigroup" :items="meta.apigroups"
                item-title="nm" item-value="id" />
              <v-select class="mb-4" :label="'API' + $t('name')"
                :items="meta.apis.filter(api => api.groupid == meta.selapigroup)" item-title="ttl" item-value="id"
                v-model="meta.newlayer.apiid"
                @update:model-value="val => meta.newlayer.apiurl = meta.apis.find(api => api.id == val).url" />
              <v-textarea class="mb-4" label="API URL" v-model="meta.newlayer.apiurl" :rules="[validators.required]" />
            </div>
          </v-defaults-provider>
          <v-row no-gutters class="mb-4">
            <v-col>
              <v-select hide-details variant="outlined" density="compact" :items="meta.groups"
                v-model="meta.newlayer.groupid" :label="$t('layergroups')"
                :item-props="item => ({ title: item.nm, value: item.id })" />
            </v-col>
            <v-col cols="3" class="text-right"><v-btn variant="outlined" size="40"
                :prepend-icon="meta.newlayer.etc === null ? 'mdi-plus' : 'mdi-minus'"
                @click="meta.newlayer.etc = meta.newlayer.etc != null ? null : ''" /></v-col>
          </v-row>
          <v-row no-gutters v-if="meta.newlayer.etc != null">
            <v-col><v-text-field variant="outlined" density="compact" :label="$t('newgroupname')" maxlength="50"
                :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]"
                v-model="meta.newlayer.etc" /></v-col>
          </v-row>
          <v-text-field variant="outlined" density="compact" v-model="meta.newlayer.nm" :label="$t('layername')"
            maxlength="50" :rules="[validators.required]"
            @update:model-value="val => meta.newlayer.nm = senitizeFileName(val)" />
        </v-container>
      </v-alert>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn color="error" variant="elevated" class="me-3" :text="$t('cancel')" @click="pop()" />
            <v-btn color="primary" variant="elevated" class="me-1" :text="$t('save')"
              :disabled="_.isEmpty(meta.newlayer.nm) || (meta.newlayer.inputtype == 'uploadfile' && meta.newlayer.file == null) || (meta.newlayer.layerkind == 'api' && _.isEmpty(meta.newlayer.apiurl))"
              @click="meta.addoverlay = 'con'" />
          </v-col>
        </v-row>
      </v-card-actions>
      <v-overlay contained :model-value="meta.addoverlay != null" class="align-center justify-center" persistent>
        <ConfirmCard v-if="meta.addoverlay == 'con'" :ttl="$t('registeringlayers')" cont="save"
          @cancel="meta.addoverlay = null" @confirm="() => {
            if (meta.poptype == 'add') addLayer()
          }" />
        <v-progress-circular v-if="meta.addoverlay == 'loading'" color="primary" size="64" indeterminate />
      </v-overlay>
    </v-card>
    <v-card v-if="meta.poptype == 'down'" min-width="290">
      <v-card-title>
        <v-row>
          <v-col>{{ $t('download') + ' ' + $t('file') }}</v-col>
          <v-col class="text-right"><v-btn size="34" variant="text" density="compact" icon="mdi-close"
              @click="pop()" /></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-select hide-details variant="outlined" density="compact" class="mb-3"
          :items="meta.downparam.service == 'wfs' ? ['WMS', 'WFS'] : ['WMS']" v-model="meta.downparam.selservice"
          @update:model-value="val => meta.downparam.format = (meta.downparam.service == 'wms' ? config.WmsDownloadFormats : config.WfsDownloadFormats)[val][0].value" />
        <v-select hide-details variant="outlined" density="compact" class="mb-3"
          :items="(meta.downparam.selservice == 'WMS' ? config.WmsDownloadFormats : config.WfsDownloadFormats)[meta.downparam.selservice]"
          v-model="meta.downparam.format" />
        <v-btn block prepend-icon="mdi-download-box-outline" color="primary" class="mb-3" :text="$t('download')"
          @click="downFile" />
      </v-card-text>
    </v-card>
  </Teleport>
</template>
<style>
.layertblcol {
  width: 200px;
}

.layertblcol>.v-card {
  max-width: calc(100vw - 420px);
}

.rastercoords .v-number-input__control button {
  border-width: 0 !important;
}

.layertbl {
  border: 1px solid #e0e0e0;
  margin-top: 18px;
}

.layertbl th {
  background-color: #eee !important;
  text-align: center !important;
  max-width: 180px;
}

.layertbl td {
  text-align: center;
}
</style>
